(() => {
  const catalogs = new Map();
  window.HilitePilotEquipment = async (root, onChange) => {
    const panel = root.querySelector('[data-equipment]');
    const labels = JSON.parse(panel.querySelector('[data-equipment-labels]').textContent);
    const fields = panel.querySelector('[data-equipment-fields]');
    const currency = root.dataset.currency || 'CHF';
    const money = (cents) => new Intl.NumberFormat(root.dataset.locale === 'de' ? 'de-CH' : 'en-CH', {style:'currency',currency,maximumFractionDigits:0}).format(cents / 100);
    let groups = [];
    const controls = [];
    let failed = false;
    try {
      if (!catalogs.has(panel.dataset.source)) catalogs.set(panel.dataset.source, fetch(panel.dataset.source).then(response => { if (!response.ok) throw new Error('Equipment unavailable'); return response.json(); }));
      const catalog = await catalogs.get(panel.dataset.source);
      groups = catalog[panel.dataset.handle]?.groups || [];
      groups.forEach((group, index) => {
        const field = document.createElement('div');
        const label = document.createElement('label');
        const select = document.createElement('select');
        select.id = `PilotEquipment-${panel.dataset.section}-${index}`;
        select.dataset.equipmentGroup = group.name;
        label.htmlFor = select.id;
        label.className = 'tp-label';
        label.textContent = root.dataset.locale === 'de' ? group.name : (group.name_en || {'Hinterradnabe':labels.hub,'Beleuchtung':labels.lighting}[group.name] || group.name);
        if (group.default_index == null) select.add(new Option((root.dataset.locale === 'de' ? group.none_label : group.none_label_en) || (group.name === 'Beleuchtung' ? labels.none : labels.base), '-1'));
        group.choices.forEach((choice, choiceIndex) => {
          const unknown = choice.surcharge_chf == null || (choice.surcharge_chf !== 0 && currency !== 'CHF');
          const adjustment = unknown ? labels.onRequest : choice.surcharge_chf === 0 ? labels.base : `+ ${money(choice.surcharge_chf * 100)}`;
          select.add(new Option(`${root.dataset.locale === 'de' ? choice.label : (choice.label_en || choice.label)} · ${adjustment}`, String(choiceIndex)));
        });
        select.value = String(group.default_index ?? -1);
        select.addEventListener('change', onChange);
        field.append(label, select);
        fields.append(field);
        controls.push({select, group, label});
      });
    } catch (error) {
      failed = true;
      panel.querySelector('[data-equipment-error]').hidden = false;
    }
    return {
      labels,
      calculate(frameOnly) {
        let delta = 0;
        let unknown = failed;
        let changed = false;
        const lines = [];
        panel.querySelector('[data-equipment-frame]').hidden = !frameOnly;
        controls.forEach(({select, group, label}) => {
          select.disabled = frameOnly;
          const selected = Number(select.value);
          if (frameOnly) return;
          if (selected < 0) { lines.push(`${label.textContent}: ${select.selectedOptions[0].textContent}`); return; }
          const choice = group.choices[selected];
          changed ||= selected !== (group.default_index ?? -1);
          const unresolved = choice.surcharge_chf == null || (choice.surcharge_chf !== 0 && currency !== 'CHF');
          if (unresolved) unknown = true;
          else delta += Math.round(choice.surcharge_chf * 100);
          lines.push(`${label.textContent}: ${select.selectedOptions[0].textContent}`);
        });
        return {delta, unknown, changed, lines};
      }
    };
  };
})();
